import { section } from '@/neon';
import Flickity from 'flickity';
import isMobile from 'is-mobile';
import { add, listen, qs, qsa } from '@fluorescent/dom';

import scrollIntoView from '@/lib/scrollIntoView';
import { onImagesLoaded } from '@/lib/images';
import isFirstSectionOnHomepage from '@/lib/homePage';
import { prefersReducedMotion, backgroundVideoHandler } from '@/lib/a11y';
import pageDots from '@/lib/pageDots';

const selectors = {
  slideshow: '.slideshow-split__slideshow',
  slide: '.slideshow-split__slide',
  innerImage: '.image__img',
  underlay: '.slideshow-split__underlay',
  video: '.slideshow-split__video',
};

section('slideshow-split', {
  events: [],
  onLoad() {
    this.slideshowContainer = qs(selectors.slideshow, this.container);
    this.slides = qsa(selectors.slide, this.container);
    this.videoElements = [];
    const underlay = qs(selectors.underlay, this.container);

    if (isFirstSectionOnHomepage(this.container)) {
      add(this.container, 'first-full-height');
    }

    if (this.slides.length > 1) {
      this._initSlideshow();

      onImagesLoaded(this.container, () => underlay.classList.remove('hide'));
    }

    this.scrollAnimation = scrollIntoView(this.container);

    this.slides.forEach(item => {
      const videoWrapper = item.querySelector(selectors.video);

      if (videoWrapper) {
        this.events.push(backgroundVideoHandler(item));
        this.videoElements.push(videoWrapper);
      }
    });

    this.autoPlayListeners = [
      listen(window, 'click', () => this._handleAutoPlay()),
      listen(window, 'touchstart', () => this._handleAutoPlay()),
    ];
  },

  _initSlideshow() {
    const slideshowOpts = {
      percentPosition: true,
      wrapAround: true,
      prevNextButtons: false,
      adaptiveHeight: false,
      pageDots: false,
      cellAlign: 'left'
    };

    const { timer, slideCount } = this.container.dataset;
    slideshowOpts.autoPlay = parseInt(timer);

    this.slideshow = new Flickity(this.slideshowContainer, {
      ...slideshowOpts,
    });

    this.pageDots = pageDots(this.container, this.slideshow, slideCount);

    this.slideshow.on('select', () => {
      this.pageDots.update(this.slideshow.selectedIndex);
    });

    this.navListener = listen(this.container, 'click', (evt) => {
      this._clickListener(evt, this.slideshow)
    });

    setTimeout(() => {
      this.slideshow.resize();
    }, 100);
  },

  _clickListener(evt, slideshow) {
    const { control } = evt.target.dataset;

    if (control === 'next') {
      evt && evt.preventDefault();
      slideshow.next();
    } else if (control === 'prev') {
      evt && evt.preventDefault();
      slideshow.previous();
    } else if (control === 'pause') {
      evt && evt.preventDefault();
      if (slideshow.player.state === 'playing') {
        slideshow.stopPlayer();
      } else {
        slideshow.playPlayer();
      }
    }
  },

  // Force autoplay after device interaction if in low power mode
  _handleAutoPlay() {
    this.videoElements.forEach(video => {
      if (!video.playing) {
        video.play();
      }
    });
    this.autoPlayListeners.forEach(unsubscribe => unsubscribe());
  },

  onUnload() {
    this.slideshow && this.slideshow.destroy();
    this.scrollAnimation.unload();
    this.events.forEach(unsubscribe => unsubscribe());
  },

  onBlockSelect({ target: slide }) {
    if (this.slideshow) {
      this.slideshow.pausePlayer();
      this.slideshow.select(slide.dataset.index);
    }
  },

  onBlockDeselect() {
    if (this.slideshow) {
      this.slideshow.unpausePlayer();
    }
  },
});
